export  class Constants {
    public static readonly COMPANY:string ='WiseLife Group';
    public static readonly LOCAL_STORAGE_DATABASE = 'database'

}
